// Material date formats (moment style tokens) - moved out of the removed NgModules
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YY', // Use 'DD-MMM-YYYY' format for parsing
  },
  display: {
    dateInput: 'DD-MMM-YY', // Use 'DD-MMM-YYYY' format for display
    monthYearLabel: 'MMM YYYY', // Format for the month/year selector
    dateA11yLabel: 'LL', // Accessibility format
    monthYearA11yLabel: 'MMMM YYYY', // Month/year accessibility format
  },
};

// Used only by the TML price-deviation screens
export const PRICE_DEVIATION_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YY',
  },
  display: {
    dateInput: 'DD-MMM-YY',
    monthYearLabel: 'MMM YY',
    dateA11yLabel: 'DD-MMM-YY',
    monthYearA11yLabel: 'MMMM YY',
  },
};
